import { Box } from "@mui/material";
import type { ReactNode } from "react";

export const PdfTemplatePageSection = ({ children }: { children: ReactNode }) => (
  <Box
    sx={{
      breakAfter: "page",
      breakInside: "avoid",
      display: "block",
      width: "100%",
    }}
  >
    {children}
  </Box>
);
